import { render, staticRenderFns } from "./BolgeItem.vue?vue&type=template&id=0eb751dc&scoped=true"
import script from "./BolgeItem.vue?vue&type=script&lang=js"
export * from "./BolgeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb751dc",
  null
  
)

export default component.exports